import { Grid, Theme, Typography, withStyles } from '@material-ui/core';
import { Button, InputField, Select, Snack } from 'bc-front-sagacomponents';
import { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';

import styles from '../../style';
import { buildMotifList, ContactFormData } from './helpers';
import { useContactForm } from './selectors';

interface Props {
  classes?: any;
  theme?: Theme;
}

const ContactForm = (props: Props) => {
  const { classes } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    setValue,
    fetching,
    errorApi,
    setParamsContactForm,
    confirmContact,
    setConfirmContact,
    immatOptionsList,
  } = useContactForm();
  const onSubmit = (data) => {
    setParamsContactForm({ ...data });
  };

  const handleChange = (id: keyof ContactFormData, value: string) => {
    methods.clearErrors();
    setValue(id, value);
  };

  useEffect(() => {
    register('motifDemande', { required: true });
    register('immatriculation', { required: true });
  }, [register]);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="h4">Par ce formulaire de contact</Typography>
        <Typography variant="body1">
          Les données du formulaire resteront au sein de Saga et de ses partenaires.
        </Typography>
        <InputField
          name="nom"
          label="Nom Prénom"
          required
          maxLength={40}
          value={watch('nom')}
          errors={errors.nom}
          register={register}
        />
        <InputField
          name="email"
          label="Email"
          value={watch('email')}
          pattern={{
            value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Merci de saisir une adresse email valide',
          }}
          required
          errors={errors.email}
          register={register}
        />
        <InputField
          name="telephone"
          label="Téléphone"
          maxLength={15}
          value={watch('telephone')}
          pattern={{
            value: /^(?:(?:\+)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/,
            message: 'Merci de saisir un numéro de téléphone valide',
          }}
          required
          errors={errors.telephone}
          register={register}
        />
        {immatOptionsList && immatOptionsList.length > 0 ? (
          <Select
            name="immatriculation"
            options={immatOptionsList}
            label="Votre demande porte sur"
            value={watch('immatriculation')}
            onChange={handleChange}
            required
            errors={errors.immatriculation}
          />
        ) : (
          <InputField
            name="immatriculation"
            label="Votre demande porte sur"
            maxLength={9}
            value={watch('immatriculation')}
            required
            errors={errors.immatriculation}
            register={register}
            placeholder="Immatriculation ou N°adhésion"
          />
        )}

        <Select
          name="motifDemande"
          options={buildMotifList}
          value={watch('motifDemande')}
          onChange={handleChange}
          required
          label="Motif de votre demande "
          errors={errors.motifDemande}
        />
        <InputField
          name="message"
          label="Message"
          maxLength={255}
          value={watch('message')}
          required
          errors={errors.message}
          register={register}
          placeholder="Votre message"
          multiline
        />
        <div className={classes.btnActions}>
          <Button variant="contained" color="primary" title={'Valider'} type="submit" fetching={fetching}></Button>
        </div>
        {!fetching && errorApi && (
          <Grid container justify="flex-end" className={classes.errorContainer}>
            <Typography color="error">{errorApi?.response?.data?.description || 'Une erreur est survenue'}</Typography>
          </Grid>
        )}
        {confirmContact && (
          <Snack
            onClose={() => setConfirmContact(false)}
            type="success"
            message="Votre demande a bien été transférée"
          />
        )}
      </form>
    </FormProvider>
  );
};

export default withStyles(styles)(ContactForm);
